// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import {
  TDashboardScores,
  TDashboardRankings,
  TDashboardTotalTrainTime,
  TDashboardWorstWeaponPresentation
} from '../../types';
import { IRootState } from './type';
import { reducers } from './reducers';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';

const initialState: IRootState = {
  worst_weapon_presentation: [] as TDashboardWorstWeaponPresentation[],
  rankings: {} as TDashboardRankings,
  scores: {} as TDashboardScores,
  total_train_time: {} as TDashboardTotalTrainTime,
};

export const slice = createSlice({
  name: STORE_SLICES.DASHBOARD_DATA,
  initialState,
  reducers,
});

const dashboardDataActions = slice.actions;

const dashboardDataPersistConfig = {
  key: PERSIST_KEYS.DASHBOARD_DATA,
  storage,
  whitelist: ['worst_weapon_presentation', 'rankings', 'scores'],
};

export { dashboardDataActions, initialState };
export default persistReducer(dashboardDataPersistConfig, slice.reducer);
